import { axios, fileAxios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesValidacion: [],
    evaluacionesValidacionExpediente: [],
  },

  getters: {
    getEvaluacionesValidacion: (state) => state.evaluacionesValidacionExpediente,
  },

  mutations: {
    SET_EVALUACIONES_VALIDACION(state, evaluacionesValidacion) {
      state.evaluacionesValidacion = evaluacionesValidacion;
    },

    SET_EVALUACIONES_VALIDACION_EXPEDIENTE(state, evaluacionesValidacionExpediente) {
      state.evaluacionesValidacionExpediente = evaluacionesValidacionExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesValidacion({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionesvalidacion')
        .then((response) => {
          commit('SET_EVALUACIONES_VALIDACION', response.data.data);
        });
    },

    async fetchEvaluacionesValidacionByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionesvalidacion`)
        .then((response) => {
          commit('SET_EVALUACIONES_VALIDACION_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionValidacion(context, evaluacionValidacion) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionValidacion.fk_idExpediente}/evaluacionesvalidacion`, evaluacionValidacion)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', evaluacionValidacion.file);
          formData.append('idValidacion', response.data.data[0].ID);
          context.dispatch('uploadEvaluacionValidacion', formData);
        });
    },

    async updateEvaluacionValidacion(_, evaluacionValidacion) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${evaluacionValidacion.fk_idExpediente}/evaluacionesvalidacion`, evaluacionValidacion);
    },

    async uploadEvaluacionValidacion(context, formData) {
      await fileAxios
        .post('/C3/SetAdjuntoValidaciones/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
